module.exports = __webpack_public_path__ + "img/d342890.jpg";